import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil } from '../../shared/core-utils';

import { SampleComponent, SampleManagerComponent } from './';
import { RouteAccessService } from '../../shared';
import { SampleGenotypeImportModalComponent } from './genotype/sample-genotype-import-modal.component';
import { SampleGenotypeImportFileComponent } from './genotype/sample-genotype-import-file.component';

@Injectable()
export class SampleResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: JhiPaginationUtil) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'sampleId,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const SAMPLE_ROOT_ROUTES: Routes = [
    {
        path: 'genotype-import/:listId',
        component: SampleGenotypeImportModalComponent,
        data: {
            pageTitle: 'bmsjHipsterApp.sample.genotypes.header',
            authorities: ['ADMIN', 'STUDIES', 'MANAGE_STUDIES', 'MS_SAMPLE_LISTS', 'MS_IMPORT_GENOTYPES_OPTIONS', 'MS_IMPORT_GENOTYPES_FROM_GIGWA'],
        },
        canActivate: [RouteAccessService]
    },
    {
        path: 'genotype-import-file/:listId',
        component: SampleGenotypeImportFileComponent,
        data: {
            pageTitle: 'bmsjHipsterApp.sample.genotypes.header',
            authorities: ['ADMIN', 'STUDIES', 'MANAGE_STUDIES', 'MS_SAMPLE_LISTS', 'MS_IMPORT_GENOTYPES_OPTIONS', 'MS_IMPORT_GENOTYPES_FROM_FILE'],
        },
        canActivate: [RouteAccessService]
    }
];

export const SAMPLE_ROUTES: Routes = [
    {
        path: 'sample-manager',
        component: SampleManagerComponent,
        resolve: {
            'pagingParams': SampleResolvePagingParams
        },
        data: {
            pageTitle: 'bmsjHipsterApp.sample.home.title',
            authorities: ['ADMIN', 'LISTS', 'SAMPLES_LISTS']
        },
        canActivate: [RouteAccessService]
    }, {
        path: 'sample',
        component: SampleComponent,
        resolve: {
            'pagingParams': SampleResolvePagingParams
        },
        data: {
            pageTitle: 'bmsjHipsterApp.sample.home.title',
            authorities: ['ADMIN', 'LISTS', 'SAMPLES_LISTS']
        },
        canActivate: [RouteAccessService]
    }
];
